import { ApplicationController } from "../../support/application-controller";

export default class extends ApplicationController {
    static targets = [
        "list",
        "dataSet",
    ];

    onDropdownChange(event) {
        const windowLocationForSelectedPackage =
            window.location.pathname.replace(this.packageName, event.target.value);
        window.location.replace(windowLocationForSelectedPackage)
    }

    onSelectAll() {
        this.dataSetTargets.forEach(dataSet => {
            // skip dataSets that are not currently visible (via filter)
            if (dataSet.classList.contains("hide")) return;
            // apply selection
            dataSet.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
                if (!checkbox.checked) {
                    checkbox.click();
                }
            })
        });
    }

    onClearAll() {
        this.dataSetTargets.forEach(dataSet => {
            // skip dataSets that are not currently visible (via filter)
            if (dataSet.classList.contains("hide")) return;
            // apply clear
            dataSet.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
                if (checkbox.checked) {
                    checkbox.click();
                }
            })
        });
    }

    onSelectDataSet(event) {
        const dataSetId = event.target.dataset.id;
        const checked = event.target.checked;
        document
            .querySelectorAll(`[id*='[${dataSetId}][available'`)
            .forEach(input => {
                if ((checked && !input.checked)
                    || (!checked && input.checked)) {
                    input.click();
                }
            });
        event.target.parentElement.nextElementSibling.classList.toggle("disabled", !checked);
    }

    onSearchChange(event) {
        const searchTerm = event.target.value.toLowerCase();
        const searchTermEmpty = searchTerm.trim() === '';
        this.dataSetTargets.forEach(dataSet => {
            const dataSetContainsSearchTerm = dataSet.querySelector("label")
                .textContent.toLowerCase().includes(searchTerm);
            const showDataSet = dataSetContainsSearchTerm || searchTermEmpty;
            dataSet.classList.toggle("hide", !showDataSet);
        })
    }

    get packageName() {
        return this.data.get("packageName");
    }
}
